import api from '../../../api';

const programApi = {
  // Program Types
  createProgramType: (data) => api.post('/api/program-types', data),
  getProgramTypes: (tenantId, status = 'active') => 
    api.get('/api/program-types', { params: { tenantId, status } }),
  updateProgramType: (typeId, data) => api.put(`/api/program-types/${typeId}`, data),

  // Programs
  createProgram: (data) => api.post('/api/programs', data),
  getPrograms: (tenantId, programTypeId = null, status = null) => 
    api.get('/api/programs', { params: { tenantId, programTypeId, status } }),
  getProgramById: (programId, tenantId) => 
    api.get(`/api/programs/${programId}`, { params: { tenantId } }),
  updateProgram: (programId, data) => api.put(`/api/programs/${programId}`, data),
  changeProgramStatus: (programId, data) => 
    api.patch(`/api/programs/${programId}/status`, data),

  // Program-Subject Mappings - Enhanced CRUD
  createProgramSubjectMapping: (data) => api.post('/api/program-subject-mappings', data),
  bulkCreateProgramSubjectMappings: (data) => api.post('/api/program-subject-mappings/bulk', data),
  bulkCreateProgramSubjectMappingsGrouped: (data) => api.post('/api/program-subject-mappings/bulk-grouped', data),

  // READ operations
  getProgramSubjectMappings: (params) => api.get('/api/program-subject-mappings', { params }),
  getGroupedProgramSubjectMapping: (params) => {
    // Only send non-empty params
    const queryParams = {};
    if (params.tenantId) queryParams.tenantId = params.tenantId;
    if (params.programId) queryParams.programId = params.programId;
    if (params.programTypeId) queryParams.programTypeId = params.programTypeId;
    if (params.academicYearId) queryParams.academicYearId = params.academicYearId;
    if (params.semesterId) queryParams.semesterId = params.semesterId;
    return api.get('/api/program-subject-mappings/grouped', { params: queryParams });
  },
  getSubjectsForProgram: (params) => api.get('/api/program-subject-mappings/subjects-for-program', { params }),
  getAvailableSubjectsForMapping: (params) => api.get('/api/program-subject-mappings/available-subjects', { params }),
  getProgramMappingsOverview: (programId, tenantId) => 
    api.get(`/api/program-subject-mappings/program/${programId}/overview`, { params: { tenantId } }),

  // UPDATE operations
  updateProgramSubjectMapping: (mappingId, data) => 
    api.put(`/api/program-subject-mappings/${mappingId}`, data),
  updateGroupedProgramSubjectMapping: (mappingId, data) =>
    api.put(`/api/program-subject-mappings/grouped/${mappingId}`, data),
  bulkUpdateProgramSubjectMappings: (data) => 
    api.patch('/api/program-subject-mappings/bulk-update', data),

  // DELETE operations
  deleteProgramSubjectMapping: (mappingId, tenantId) => 
    api.delete(`/api/program-subject-mappings/${mappingId}`, { data: { tenantId } }),
  deleteGroupedProgramSubjectMapping: (mappingId, tenantId) =>
    api.delete(`/api/program-subject-mappings/grouped/${mappingId}`, { data: { tenantId } }),
  bulkDeleteProgramSubjectMappings: (data) => 
    api.post('/api/program-subject-mappings/bulk-delete', data),
  deleteAllProgramMappings: (programId, academicYearId, semesterId, tenantId) =>
    api.delete('/api/program-subject-mappings/delete-all', { 
      data: { programId, academicYearId, semesterId, tenantId } 
    }),

  // Academic Data - with authentication
  getAcademicYears: (tenantId) => {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    return api.get(`/api/academic-year/all-active?tenantId=${tenantId}`, { headers });
  },
  getSemesters: (academicYearId) => {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    return api.get(`/api/classManager/semesters/${academicYearId}`, { headers });
  },
  getDepartments: (tenantId) => {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    return api.get(`/api/departments/${tenantId}`, { headers });
  },
  getSubjectsForDepartmentContext: (departmentId, academicYearId, semesterId = null) => {
    const token = localStorage.getItem('token');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const params = {
      tenantId: localStorage.getItem('tenantId'),
      academicYearId,
      departmentId
    };
    if (semesterId) params.semesterId = semesterId;
    return api.get('/api/subjects/class-manager/subjects/department/context', { headers, params });
  }
};

export default programApi;